import * as React from 'react';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../../../reducers';
import Slide from '../../../../containers/Editor/EditPanel/SliderPanel/Slide';
import { SlideData, ImportingSlideData } from '../../../../containers/Editor/utils/indesignEditor/editableSliders/getData';
import SliderManager from '../../../../containers/Editor/EditPanel/SliderManager';
import { importSlides, updateEditableSlider, updateEditableSliderConfig } from '../../../../containers/Editor/actions';

interface SliderPanelProps {
	page: number;
	id: string;
	idInConfigs: string;
	slides: SlideData[];
	importingSlides: ImportingSlideData[];
	deps: string[];
	sliderWidth: number;
	sliderHeight: number;
	shouldScaleImage: boolean;
	dispatch: Dispatch<StoreState>;
}

const SliderPanel = ({
	page,
	id,
	idInConfigs,
	slides,
	importingSlides,
	deps,
	sliderWidth,
	sliderHeight,
	shouldScaleImage,
	dispatch,
}: SliderPanelProps) => (
	<SliderManager
		page={page}
		id={id}
		idInConfigs={idInConfigs}
		slides={slides}
		importingSlides={importingSlides}
		deps={deps}
		SlideComponent={Slide}
		sliderWidth={sliderWidth}
		sliderHeight={sliderHeight}
		shouldScaleImage={shouldScaleImage}
		onImportSlides={(page, id, idInConfigs, newSlidesData, isFromDesktop) => dispatch(importSlides(page, id, idInConfigs, newSlidesData, isFromDesktop))}
		onUpdateSliderConfig={(page, id, data) => dispatch(updateEditableSliderConfig(page, id, data))}
		onUpdateSliderElement={(page, id, data, shouldSave, isFirstSlideChanged) => dispatch(updateEditableSlider(page, id, data, shouldSave, isFirstSlideChanged))}
	/>
);

export default SliderPanel;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/SliderPanel/index.tsx